import './../less/bootstrap.less';
import './../less/SiteFRC.less';
import './../less/spinner.less';
import './../less/EventDropdown.less';
import './../less/boldreports.less';

// Restores jQuery APIs removed in 4.x (e.g. $.trim) that legacy plugins like
// tablesorter still call directly.
import "jquery-migrate";

import "bootstrap";
import "tablesorter";

// begin test code
export function myAppTestFunction():string {
    console.log('myAppTestFunction');
    return 'myjunk';
}
export function myAppTestFunctionWithParam(param:string) {
    console.log(`myAppTestFunction with param ${param}`);
}
// end test code